module.exports = __webpack_public_path__ + "img/nut.93107e47.png";